<div class="ar-preview-container">
  <div class="close-icon">
    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;" (click)="cancel()">close</mat-icon>
  </div>
  <div class="title">AR Model</div>
  <ng-container *ngIf="canPreview">
    <model-viewer style="width:500px;height:450px" camera-controls ar ar-modes="webxr scene-viewer quick-look" [src]="getFileUrl(floorPlan.urls.android)"
                  [ios-src]="getFileUrl(floorPlan.urls.ios)" [alt]="floorPlan.notes" data-js-focus-visible="" ar-status="not-presenting">
    </model-viewer>
  </ng-container>

  <ng-container *ngIf="!canPreview">
    <p style="text-align: center;">IOS preview currently not supported.</p>
  </ng-container>

<!--  <model-viewer style="width:500px;height:450px" camera-controls ar ar-modes="webxr scene-viewer quick-look" [src]="getFileUrl(floorPlan.urls.ios)"-->
<!--                [ios-src]="getFileUrl(floorPlan.urls.ios)" [alt]="floorPlan.notes" data-js-focus-visible="" ar-status="not-presenting">-->
<!--  </model-viewer>-->
</div>
